import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Order } from "@models/order";
import { Page } from "@models/page";
import { PaginatorModule, PaginatorState } from "primeng/paginator";
import { SkeletonModule } from "primeng/skeleton";
import { LoadingComponent } from "../../../../shared/components/loading/loading.component";
import { OrderCardComponent } from "./order-card/order-card.component";

@Component({
  selector: "app-order-list",
  imports: [
    SkeletonModule,
    OrderCardComponent,
    LoadingComponent,
    PaginatorModule,
  ],
  templateUrl: "./order-list.component.html",
  styleUrl: "./order-list.component.scss",
})
export class OrderListComponent {
  @Input() orderList: Page<Order> | null = null;
  @Input() isMobile = false;
  @Input() isPastEvents = false;

  @Output() openDetailsModalClick = new EventEmitter<Order>();
  @Output() reloadTicketsAfterChange = new EventEmitter();
  @Output() loadMoreClick = new EventEmitter<PaginatorState>();
  @Output() paymentClick = new EventEmitter<Order>();

  first = 0;
  rows = 10;

  handleOpenModalClick(order: Order) {
    this.openDetailsModalClick.emit(order);
  }

  handleReloadTicketsAfterChange() {
    this.reloadTicketsAfterChange.emit();
  }

  handleLoadMoreClick(pageEvent: PaginatorState) {
    if (!this.orderList) {
      return;
    }
    const page: PaginatorState = {
      page: pageEvent.page ? pageEvent.page + 1 : 0,
      rows: pageEvent.rows,
    };

    this.first = pageEvent.first ?? 0;
    this.rows = pageEvent.rows ?? 10;

    this.loadMoreClick.emit(page);
  }

  handlePaymentClick(order: Order) {
    this.paymentClick.emit(order);
  }
}
